import { createRouter, createWebHistory, RouteLocationRaw } from "vue-router";

import { useGeneralStore } from "@/store/general.store";
import { useAuthStore } from "@/store/auth.store";
import { displayMessage } from "@/store/message.store";

import { ROUTES } from "./routes";
import { AppRouteRecordRaw } from "./types";

/*###########################
### INICJALIZACJA ROUTERA ###
###########################*/
const router = createRouter({
    routes: Object.values(ROUTES) as unknown as AppRouteRecordRaw[],
    history: createWebHistory()
});

/*##################
### ROUTE GUARDS ###
##################*/
router.beforeEach(async (to): Promise<boolean | RouteLocationRaw> => {
    const GENERAL_STORE = useGeneralStore();
    // 1. Jeżeli apka się jeszcze nie zbootowała to grzecznie czekamy
    await GENERAL_STORE.app_boot_promise;

    // 2. Sprawdzamy autoryzację dla routów niepublicznych
    const AUTH_STORE = useAuthStore();
    if (to.meta.public !== true && !AUTH_STORE.is_logged_in) {
        displayMessage({
            type: "error",
            msg: "Zaloguj się, aby uzyskać dostęp do tej części aplikacji",
            duration: 4000
        });

        return {
            name: "dashboard-auth-login",
            query: {
                rback: to.fullPath
            },
            replace: true
        };
    }

    // 3. Sprawdzamy autoryzację dla routes zabezpieczonych od roli
    if (
        to.meta.public === true &&
        to.meta.allowed_roles &&
        (!AUTH_STORE.user || !to.meta.allowed_roles.includes(AUTH_STORE.user.role))
    ) {
        displayMessage({
            type: "error",
            msg: "Nie posiadasz dostępu do tej części serwisu",
            duration: 4000
        });
        return false;
    }

    // 4. Git, może lecieć gdzie zechciał
    return true;
});

export default router;
